module.exports = __webpack_public_path__ + "img/BOTELLAGOLDAPPLE.2d05d9f7.png";